import en from './en.json';

const widgetTranslations = {
    en: { translation: en },
};

// TODO: Russian has not yet been proofreaded!
export type WidgetTranslationLocale = 'en' | 'pl' | 'sv' | /* 'ru' | */ 'el' | 'ko';
export type WidgetTranslationResources = typeof widgetTranslations.en;

const widgetTranslationLoaders: Record<
    Exclude<WidgetTranslationLocale, 'en'>,
    () => Promise<WidgetTranslationResources>
> = {
    pl: () => import('./pl.json').then(({ default: translation }) => ({ translation })),
    sv: () => import('./sv.json').then(({ default: translation }) => ({ translation })),
    // ru: () => import('./ru.json').then(({ default: translation }) => ({ translation })),
    el: () => import('./el.json').then(({ default: translation }) => ({ translation })),
    ko: () => import('./ko.json').then(({ default: translation }) => ({ translation })),
};

export const widgetTranslationLocales: WidgetTranslationLocale[] = [
    'en',
    'pl',
    'sv',
    // 'ru',
    'el',
    'ko',
];

const widgetLocaleAliases: Record<string, WidgetTranslationLocale> = {
    'el-GR': 'el',
    'en-GB': 'en',
    'en-US': 'en',
    'ko-KR': 'ko',
    'pl-PL': 'pl',
    // 'ru-RU': 'ru',
    'sv-SE': 'sv',
};

export const normalizeWidgetLanguage = (locale?: string): string => {
    if (!locale) return 'en';

    return locale.replace(/_/g, '-');
};

const isWidgetTranslationLocale = (
    locale: string,
): locale is WidgetTranslationLocale =>
    widgetTranslationLocales.some(
        (supportedLocale) => supportedLocale === locale,
    );

const getSupportedLocale = (locale: string): WidgetTranslationLocale | undefined => {
    const normalizedLocale = normalizeWidgetLanguage(locale);

    if (isWidgetTranslationLocale(normalizedLocale)) return normalizedLocale;
    if (normalizedLocale in widgetLocaleAliases) {
        return widgetLocaleAliases[normalizedLocale];
    }

    const [baseLocale] = normalizedLocale.split('-');

    if (isWidgetTranslationLocale(baseLocale)) return baseLocale;

    return undefined;
};

export const normalizeWidgetLocale = (
    locale?: string,
): WidgetTranslationLocale => {
    if (!locale) return 'en';

    return getSupportedLocale(locale) ?? 'en';
};

export const loadWidgetTranslation = async (
    locale?: string,
): Promise<WidgetTranslationResources> => {
    const normalizedLocale = normalizeWidgetLocale(locale);

    if (normalizedLocale === 'en') return widgetTranslations.en;

    return widgetTranslationLoaders[normalizedLocale]();
};

export default widgetTranslations;
